export default __webpack_public_path__ + "static/media/hand2.85888462.svg";